import Driving from "./Driving";

export const qaDriving = [
  {
    index: "driving1",
    question: "德國駕照",
    answer: "",
    link: <Driving />,
  },
];
